import React from 'react';
import { FileTextIcon, BrainCircuitIcon, MessageSquareIcon, UsersIcon, WalletIcon, FileOutputIcon } from 'lucide-react';
export const FeatureSection = () => {
  const features = [{
    icon: <WalletIcon className="h-8 w-8 text-blue-600" data-id="element-100" />,
    title: 'Bank- & Transaktionsimport',
    description: 'Verknüpfe deine Bankkonten, Kreditkarten und Zahlungsdienste für automatischen Transaktionsimport.'
  }, {
    icon: <FileTextIcon className="h-8 w-8 text-blue-600" data-id="element-101" />,
    title: 'Intelligente Belegverwaltung',
    description: 'Belege hochladen per Web, E-Mail oder App – OCR extrahiert automatisch alle wichtigen Informationen.'
  }, {
    icon: <BrainCircuitIcon className="h-8 w-8 text-blue-600" data-id="element-102" />,
    title: 'KI-Zuordnung',
    description: 'Unsere KI ordnet Belege automatisch den passenden Transaktionen zu und schlägt Kategorien vor.'
  }, {
    icon: <MessageSquareIcon className="h-8 w-8 text-blue-600" data-id="element-103" />,
    title: 'Chatbot-Assistenz',
    description: 'Erhalte Hilfe bei unklaren Buchungen und lass dir von unserem KI-Assistenten Vorschläge machen.'
  }, {
    icon: <FileOutputIcon className="h-8 w-8 text-blue-600" data-id="element-104" />,
    title: 'Export für Steuerberater',
    description: 'Exportiere deine Daten im DATEV-Format oder übermittle sie direkt an die Kanzleisoftware.'
  }, {
    icon: <UsersIcon className="h-8 w-8 text-blue-600" data-id="element-105" />,
    title: 'Zusammenarbeit',
    description: 'Arbeite mit deinem Team und Steuerberater zusammen mit rollenbasierten Zugriffsrechten.'
  }];
  return <section id="features" className="w-full bg-white py-16 md:py-24" data-id="element-106">
      <div className="container mx-auto px-4" data-id="element-107">
        <div className="text-center mb-12" data-id="element-108">
          <h2 className="text-3xl font-bold text-gray-900 mb-4" data-id="element-109">
            Alles was du brauchst für eine stressfreie Buchhaltung
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto" data-id="element-110">
            TaxTidy automatisiert die lästigsten Aufgaben deiner Buchhaltung und
            spart dir wertvolle Zeit.
          </p>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8" data-id="element-111">
          {features.map((feature, index) => <div key={index} className="bg-gray-50 rounded-lg p-6 hover:shadow-md transition" data-id="element-112">
              <div className="mb-4" data-id="element-113">{feature.icon}</div>
              <h3 className="text-xl font-semibold text-gray-900 mb-2" data-id="element-114">
                {feature.title}
              </h3>
              <p className="text-gray-600" data-id="element-115">{feature.description}</p>
            </div>)}
        </div>
      </div>
    </section>;
};